/**
 * Get data for single exercise
 */

import { GET_EXERCISE, SHOW_SPINNER, HIDE_SPINNER, SHOW_NOTIFICATION } from '../types';
import api from '../../api';
import sessionErrHandler from './sessionErrHandler';

// Todo: tutaj należy zmienić dane wejściowe tak, żeby uwzględniały elementType
export const getExercise = (exercise) => async dispatch => {
  dispatch({ type: SHOW_SPINNER, payload: '' });
  const url = `/course/${getUrl(exercise)}`;
  let response;
  try {
    response = await api.get(url, { withCredentials: true });
    if (response.status === 200) {
      const id = `${exercise.type}_${exercise.id}`;
      dispatch({ type: GET_EXERCISE, payload: { id, data: response.data } });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd podczas pobierania ćwiczenia', type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd podczas pobierania ćwiczenia', dispatch);
  }
  dispatch({ type: HIDE_SPINNER });
}

function getUrl(exercise) {
  const { type, elementType } = exercise;
  const id = parseInt(exercise.id);
  let url = elementType.toLowerCase() + '/';
  if (type) url += type + '/';
  url += id;
  return url;
}
